import { render, staticRenderFns } from "./SelectClub.vue?vue&type=template&id=1b3c0682&scoped=true&"
import script from "./SelectClub.vue?vue&type=script&lang=js&"
export * from "./SelectClub.vue?vue&type=script&lang=js&"
import style0 from "./SelectClub.vue?vue&type=style&index=0&id=1b3c0682&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3c0682",
  null
  
)

export default component.exports